import React from 'react';
import PropTypes from 'prop-types';

import {Dialog, DialogActions, DialogContent, DialogTitle} from 'views/components';
import {Stack, Typography, Button} from 'views/components';
import {WarningAmber} from 'views/icons';
import {Translate} from 'views/module';

const RemoveEvent = (props) => {
  const event = props.event;
  const onClose = props.onClose;
  const removeEvent = props.removeEvent;

  return (
    <Dialog onClose={onClose} open={true}>
      <DialogTitle onClose={onClose}>
        <Translate expression="client.ClientDetail.Scheduling.DeleteEvent" />
      </DialogTitle>
      <DialogContent>
        <Stack spacing={1} >
          <Stack>
            <Typography
              sx={{
                fontWeight: 600,
              }}
            >
              <Translate expression='client.ClientDetail.Scheduling.ScheduleDetail.EventInfo.Title'/>
            </Typography>
            <Typography
              sx={{
                fontSize: '14px',
              }}
            >
              {event.info.title}
            </Typography>
          </Stack>
          <Stack
            direction='row'
            spacing={1}
            sx={{
              backgroundColor: 'grey.200',
              borderRadius: '8px',
              color: 'error.main',
              p: 1,
              py: 2,
            }}
          >
            <WarningAmber/>
            <Translate
              expression='generic.DeleteConfirm'
            />
          </Stack>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant='outlined' onClick={onClose}>
          <Translate expression='generic.Close' />
        </Button>
        <Button color="error" variant="contained" onClick={() => removeEvent(event, '')}>
          <Translate expression='generic.Delete' />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

RemoveEvent.propTypes = {
  eventRn: PropTypes.string.isRequired,
  event: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  removeEvent: PropTypes.func.isRequired,
};

export default React.memo(RemoveEvent);
